import { push } from "react-router-redux";
import { get } from "lodash";
import { toastr } from "react-redux-toastr";
import { expireAll } from "@orange-marmalade/paginate-this";
import api from "APP_ROOT/api";
import session from "APP_ROOT/session";
import { subscribe, unsubscribe } from "APP_ROOT/channels/notification";
import moment from "moment";
import { UUID } from "APP_ROOT/constants";
import { USER } from "MODULES/users/constants";
import * as actionTypes from "./actionTypes";

export function login(user, settings) {
  subscribe();

  const { full_name: fullName, email, created_at, intercom_hash: hash } = user;

  window.Intercom("boot", {
    api_base: "https://api-iam.intercom.io",
    app_id: "uo2xpwcp",
    name: fullName,
    email,
    user_hash: hash,
    created_at
  });

  return {
    type: actionTypes.LOGIN,
    user,
    settings
  };
}

export function update(user) {
  const { full_name: fullName, email, created_at, intercom_hash: hash } = user;

  window.Intercom("boot", {
    api_base: "https://api-iam.intercom.io",
    app_id: "uo2xpwcp",
    name: fullName,
    email,
    user_hash: hash,
    created_at
  });

  return {
    type: actionTypes.UPDATE,
    user
  };
}

export function clear() {
  return { type: actionTypes.CLEAR };
}

export function expire() {
  return dispatch => {
    unsubscribe();
    session.logout();
    dispatch(push("/login"));
    dispatch(clear());
    dispatch(expireAll());
  };
}

export function refreshCarts() {
  return (dispatch, getState) =>
    api.users
      .show(getState().session.getIn([USER, UUID]))
      .then(({ data: user }) => {
        dispatch({
          type: actionTypes.REFRESH_CARTS,
          user
        });
      });
}

export function setCarts({ bookmarks, repairCartItems, salesCartItems }) {
  return dispatch =>
    dispatch({
      type: actionTypes.SET_CARTS,
      bookmarks,
      repairCartItems,
      salesCartItems
    });
}

export function logout() {
  return dispatch => api.session.logout().then(() => dispatch(expire()));
}

export function loginError(message) {
  return { type: actionTypes.LOGIN_ERROR, message };
}

export function setPushId(pushId) {
  return { type: actionTypes.PUSH_ID, pushId };
}

function initializeRollbarForUser(user) {
  if (process.env.ROLLBAR_CLIENT_ACCESS_TOKEN) {
    try {
      // eslint-disable-next-line
      Rollbar.configure({
        payload: {
          person: {
            id: user.id,
            username: user.full_name,
            email: user.email
          }
        }
      });
    } catch (ex) {
      // eslint-disable-next-line
      console.log("Unable to initialize Rollbar for user");
    }
  }
}

export function authenticate(user) {
  return dispatch =>
    api.session
      .authenticate(user)
      .then(resp => {
        dispatch(
          login(resp.data.user, get(resp, "data.settings.settings", {}))
        );

        const {
          bookmarks,
          repair_order_cart_items: repairCartItems,
          sales_order_cart_items: salesCartItems
        } = resp.data.user;
        dispatch({
          type: actionTypes.SET_CARTS,
          bookmarks,
          repairCartItems,
          salesCartItems
        });

        let message = `Welcome, ${resp.data.user.full_name}.`;

        let path = "/";
        if (resp.data.user.password_reset_at) {
          const diff = moment().diff(
            moment(resp.data.user.password_reset_at),
            "days"
          );

          const {
            full_name: fullName,
            email,
            created_at,
            intercom_hash: hash
          } = resp.data.user;

          if (!["development", "staging"].includes(process.env.NODE_ENV)) {
            /* eslint-disable no-undef */
            Upscope("updateConnection", {
              uniqueId: resp.data.user.id,
              identities: [fullName, email]
            });
          }

          window.Intercom("boot", {
            api_base: "https://api-iam.intercom.io",
            app_id: "uo2xpwcp",
            name: fullName,
            email,
            user_hash: hash,
            created_at
          });

          const daysUntilExpiration = 90 - diff;

          if (daysUntilExpiration <= 5) {
            path = `/users/${resp.data.user.uuid}`;
            toastr.error(
              `PLEASE RESET YOUR PASSWORD OR YOU WILL BE LOCKED OUT IN ${daysUntilExpiration} DAY/S.`
            );
          } else {
            message += `You have ${daysUntilExpiration} days until your password expires.`;
            toastr.success("Logged In", message);
          }
        }

        dispatch(push(path));

        initializeRollbarForUser(resp.data.user);
      })
      .catch(err => {
        if (err.status === 418) {
          dispatch(setPushId(err.push_id));
        } else {
          dispatch(loginError(err.response.data.message));
        }
      });
}



// WEBPACK FOOTER //
// ./app/modules/session/actions.js